import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EventPhotosResolver } from './event-photos/event-photos.resolver';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PortfolioResolver } from './portfolio/portfolio.resolver';
import { OrderResolver } from './portfolio/order.resolver';
import { CategoryResolver } from './portfolio/category.resolver';
import { selectionsViewResolver } from './event-photos/selections-view.resolver';

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  providers: [
    // provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
  imports: [
    RouterModule.forRoot(
      [
        { path: '', loadComponent: () => import('./portfolio/portfolio.component').then(m => m.PortfolioComponent), resolve: { data: PortfolioResolver } },
        /*A category*/{ path: 'c/:code', loadComponent: () => import('./portfolio/category/category.component').then(m => m.CategoryComponent), resolve: { data: CategoryResolver } },
        /*An order (order/booking details)*/ { path: 'o/:code', loadComponent: () => import('./portfolio/order/order.component').then(m => m.OrderComponent), resolve: { data: OrderResolver } },
        /*Supervisor link for gallery photos selections for a gallery*/ { path: 's/:code', loadComponent: () => import('./event-photos/selections-view/selections-view.component').then(m => m.SelectionsViewComponent), resolve: { data: selectionsViewResolver } },
        { path: 'p/:code', loadComponent: () => import('./event-photos/event-photos.component').then(m => m.EventPhotosComponent), resolve: { data: EventPhotosResolver } },
        { path: 'p/:code/:title', loadComponent: () => import('./event-photos/event-photos.component').then(m => m.EventPhotosComponent), resolve: { data: EventPhotosResolver } },
        { path: ':code', loadComponent: () => import('./event-photos/event-photos.component').then(m => m.EventPhotosComponent), resolve: { data: EventPhotosResolver } },
        { path: ':code/:title', loadComponent: () => import('./event-photos/event-photos.component').then(m => m.EventPhotosComponent), resolve: { data: EventPhotosResolver } },
      ]
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
